import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  DataStateChangeEvent,
  GridDataResult,
  PageChangeEvent,
  RowArgs,
  SelectableSettings,
} from '@progress/kendo-angular-grid';
import {
  FileInfo,
  FileRestrictions,
  FileState,
} from '@progress/kendo-angular-upload';
import { State, process } from '@progress/kendo-data-query';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { CartService } from 'src/app/core/services/cart.service';
import * as Excel from 'exceljs/dist/exceljs.min.js';
import { ItemService } from 'src/app/core/services/item.service';
import { MasterDataService } from 'src/app/core/services/master-data.service';
import { ApiService } from 'src/app/core/services/api.service';
import {
  ImportItemFromExcel, CartItem, Finish, IImportItemFromExcel, ICartItem, IExtrusion, IFinish,
  IFilterItemRequest, IImportExcelUpload, IItemList, IUser, ItemSuggestion, IBaseResponse, IApiResultResponse,
  IAddCartToQuoteBody,
  ICartItemResponse,
  QuoteItem,
  IImportLbl
} from 'src/app/core/models';
import { Observable, Subject } from 'rxjs';
import { QuoteService } from '../../../core/services/quote.service';
import { UserService } from '../../../core/services/user.service';
import { Info } from '../../../core/common';
import { ProductService } from '../../../core/services/product.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { clone, forEach } from 'lodash';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';

@Component({
  selector: 'app-import-item',
  templateUrl: './import-item.component.html',
  styleUrls: ['./import-item.component.scss']
})
export class ImportItemComponent implements OnInit {
  importLblTxt: IImportLbl;
  public importExcelItems: ImportItemFromExcel[] = [];
  public excelItems: string[] = [];
  public myRestrictions: FileRestrictions = {
    allowedExtensions: ['jpg', 'jpeg', 'png']
  };
  public paintValue: Array<any> = [];

  @Input() inputData: any;
  @Output() importCompleteEvent = new EventEmitter<any>();
  constructor(private cartService: CartService, private masterService: MasterDataService,
    private appNotify: AppNotifyService, private quoteService: QuoteService, private languageTranslationService: LanguageTranslationService) { }

  ngOnInit() {
    this.resetImportDialogStatus();
    this.paintValue = this.masterService.getPaintValues();
    this.loadLanguageTranslationData();
  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [     
      { controlName: "uploadItemToExcelLbl" },
      { controlName: "excelFileUploadLbl" },
      { controlName: "importContentLbl1" },
      { controlName: "importContentLbl2" },
      { controlName: "importContentLbl3" },
      { controlName: "importContentLbl4" },
      { controlName: "importContentLbl5" },
      { controlName: "importContentLbl6" },
      { controlName: "importContentLbl7" },
      { controlName: "importContentLbl8" },
      { controlName: "importContentLbl9" },
      { controlName: "importContentLbl10" },
      { controlName: "importContentLbl11" },
      { controlName: "importContentLbl12" },
      { controlName: "importContentLbl13" },
      { controlName: "importContentLbl14" },
      { controlName: "clickLbl" },
      { controlName: "uploadLbl" },
      { controlName: "importSuccessMessageLbl" },
      { controlName: "importSuccessMessageLbl1" },      
    ];
    const componentName = "import";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.importLblTxt = response[response.length - 1];
      console.log(response);
    }

  }


  //#endregion


  //#region label declaration
  public import = {    
    uploadItemToExcelLbl: 'Upload Items From Excel',
    excelFileUploadLbl: 'Requirement for Excel file upload',
    importContentLbl1: 'You may add any contents (like text) in row 1. Contents for row 1 will not be uploaded',
    importContentLbl2: 'Data from row 2 upto row 1000 will be uploaded.',
    importContentLbl3: ' Column 1 must be the item name and column 2 must be item quantity.',
    importContentLbl4: 'Any aditional columns after column 2 will be iqnored.',
    importContentLbl5: 'A maximum of 999 items can be uploaded at one time from Excel. Any rows after row 1000 in the Excel file will be ignored.',
    importContentLbl6: 'To upload more than 999 items, you must upload them in multiple batches with a maximum of 999 items at a time.',
    importContentLbl7: 'Note that you can not upload configured items or kit items.',
    importContentLbl8: 'Item quantity (column 2) must be between 1 to 999.',
    importContentLbl9: 'A sheet name is mandatory.Enter the correct sheet name.', 
    importContentLbl10: 'To download a sample Excel file,',
    importContentLbl11: 'Enter the Excel Details below and then click',
    clickLbl: 'Click',
    uploadLbl: 'Upload',
    importSuccessMessageLbl: 'Uploading.......',
    importSuccessMessageLbl1: 'All Item successfully added to Cart',
    errorMessage: 'Cannot use multiple files',    
  }
  //#endregion


  public importExcelUpload: IImportExcelUpload = {
    uploadSaveUrl: 'saveUrl', // should represent an actual API endpoint
    uploadRemoveUrl: 'removeUrl', // should represent an actual API endpoint
    show: false,
    toggleText: 'Show',
    myRestrictions: {
      allowedExtensions: ['xlsx'],
    },
    userImages: [],
    showInfo: false,
  };
 
  sendMessageToCallingComponent() {
    this.importCompleteEvent.emit(this.inputData);
  }
  onToggleImportExcelUploadInfo(): void {
    this.importExcelUpload.showInfo = !this.importExcelUpload.showInfo;
  }

  public removeUploadFile(upload, uid: string) {
    upload.removeFilesByUid(uid);
  }
  public showButton(state: FileState): boolean {
    console.log(state);
    return state === FileState.Uploaded ? true : false;
  }

  public onimportExcelUploadToggle(): void {
    this.importExcelUpload.show = !this.importExcelUpload.show;
    this.importExcelUpload.toggleText = this.importExcelUpload.show
      ? 'Hide'
      : 'Show';
  }
  resetImportDialogStatus() {
    this.inputData.isError = false;
    this.inputData.isSuccess = false;
    this.inputData.successMessage = '';
    this.inputData.errorMessage = '';
  }
  //public inputData($event) {
  //  this.inputData.showInfo = !this.importDialog.showInfo;
  //}
  public importDialogClose() {
    this.inputData.opened = false;
    this.resetImportDialogStatus();
  }



  public importDialogSubmit() {
    this.inputData.dataSaved = true;
    this.importDialogClose();
  }

  public getData() {
    console.log(this.importExcelItems);
    alert(JSON.stringify(this.importExcelItems));
  }


  public uploadItems(): void {
    if (this.importExcelItems.length < 1 || !this.importExcelItems) {
      // this.appNotify.notify(NotifyType.ERROR, "Cannot use multiple files")
      this.inputData.isError = true;
      this.inputData.errorMessage = 'Cannot use multiple files';
    }
    const body: IImportItemFromExcel[] = this.importExcelItems;
    this.inputData.isSuccess = true;
    this.inputData.successMessage = 'Uploading.......';
    const data = [];
    let item: any;
    this.importExcelItems.forEach((el, index) => {
      if (this.inputData.mode === "import-to-cart") {
        item = new CartItem();
      } else {
        item = new QuoteItem();
        item.quoteCommonId = this.quoteService.selectedQuoteHeader.quoteCommonId;
      }
      item.OrderSource = 1;
      item.longItemNumber = el.itemNumber.toString().toUpperCase();
      item.quantity = parseInt(el.itemQuantity);
      const temp = el.itemNumber.toString().split("-");
      item.itemNumber = temp.length > 0 ? temp[0].toUpperCase() : "";//invalid
      item.finishValue = temp.length > 1 ? temp[1].toUpperCase() : "";
      item.size = temp.length > 2 ? temp[2].toUpperCase() : "";
      if (item.finishValue === "22") {
        item.paint = el.paintNumber && el.paintNumber.length > 0 ? el.paintNumber.toUpperCase() : "";
        var tempPaint = this.paintValue.find(p => p.value === item.paint);
        item.paintName = tempPaint ? tempPaint.name : null;
        item.paint = tempPaint ? item.paint : null;
      }
      data.push(item);


    });
    if (this.inputData.mode === "import-to-cart") {
      this.cartService.uploadItems(data).subscribe(r => {
        //this.gridUpdateOnQuickAddSubmit(r.modifiedCartItems as ICartItem[]);//--we can load full grid
        //this.loadCartGrid();//--loading grid again
        this.inputData.dataSaved = true;
        this.sendMessageToCallingComponent();
        this.inputData.successMessage = r.statusMessage;
      }, error => {
        this.inputData.successMessage = '';
        this.inputData.errorMessage = 'An error Occur';
        this.appNotify.notify(NotifyType.ERROR, 'An error Occur');
      });
    } else {
      this.quoteService.uploadItems(data).subscribe(r => {
        //var a = r.modifiedQuoteItems as IQuoteItem[];
        //this.gridUpdateOnQuickAddSubmit(r.modifiedQuoteItems as IQuoteItem[]);
        //this.loadKdQuoteItemssGrid();
        this.inputData.dataSaved = true;
        this.sendMessageToCallingComponent();
        this.inputData.successMessage = r.statusMessage;
      }, error => {
          this.inputData.isError = true;
          this.inputData.isSuccess = false;
          this.inputData.successMessage = 's An error Occur. Please check the format of spreadsheet and try again.Note that item number and quantity is mandatory.';
          this.inputData.errorMessage = 'An error Occur. Please check the format of spreadsheet and try again.Note that item number and quantity is mandatory.';
          this.appNotify.notify(NotifyType.ERROR, 'An error Occur. Please check the format of spreadsheet and try again. Note that item number and quantity is mandatory.');
      });
    }
  }

  public readExcel(event) {
    this.resetImportDialogStatus();
    const target: DataTransfer = (event.target) as DataTransfer;
    if (target.files.length !== 1) {
      this.appNotify.notify(NotifyType.ERROR, 'Cannot use multiple files');
      throw new Error('Cannot use multiple files');
    }

    /**
     * Final Solution For Importing the Excel FILE
     */

    const arryBuffer = new Response(target.files[0]).arrayBuffer();
    this.importExcelItems = this.readExcelBuffer(arryBuffer);




  }

  public readExcelBuffer(arryBuffer): IImportItemFromExcel[] {

    const tempImportExcelItems = [];
    const workbook = new Excel.Workbook();
    arryBuffer.then(function (data) {
      workbook.xlsx.load(data)
        .then(function () {
          // play with workbook and worksheet now
          console.log(workbook);
          const worksheet = workbook.getWorksheet(1);
          console.log('rowCount: ', worksheet.rowCount);
          worksheet.eachRow(function (row, rowNumber) {
            //console.log('Row: ' + rowNumber + ' Value: ' + row.values);

            if (rowNumber > 1) {
              // console.log(row.values);
              tempImportExcelItems.
                push(({ itemNumber: row.values[1], itemQuantity: row.values[2], paintNumber: row.values[3] }) as ImportItemFromExcel);

            }


          });
          console.log(tempImportExcelItems);
          return tempImportExcelItems;
        });
    });
    return tempImportExcelItems;
  }

  public importExcelUploadSelectEventHandler(event) {
    console.log(event);
    if (event) {
      if (event.files as FileInfo[]) {
        console.log(event.files[0]);

        const formData = new FormData();
        formData.append('FileUpload', event.files[0]);
        console.log(formData.getAll('FileUpload'));

        // read from a file
        const workbook = new Excel.Workbook();
        // await workbook.xlsx.readFile(filename);
        // ... use workbook


        /**
         * Final Solution For Importing the Excel FILE
         */

        const arryBuffer = new Response(event.files[0]).arrayBuffer();
        arryBuffer.then(function (data) {
          workbook.xlsx.load(data)
            .then(function () {

              // play with workbook and worksheet now
              console.log(workbook);
              const worksheet = workbook.getWorksheet(1);
              // console.log('rowCount: ', worksheet.rowCount);
              worksheet.eachRow(function (row, rowNumber) {
                // console.log('Row: ' + rowNumber + ' Value: ' + row.values);
              });

            });
        });

        setTimeout(() => {
          this.appNotify.notify(NotifyType.SUCCESS, 'Uploaded');

        }, 5000);

        // this.cartService.importCartFile(formData).subscribe(result => {
        //  console.log(result);


        // });
      }
    }
  }
  public importExcelUploadClearEventHandler(event) {
    console.log(event);
  }
  public importExcelUploadRemoveEventHandler(event) {
    console.log(event);
  }
  public importExcelUploadCompleteEventHandler(event) {
    console.log(event);
  }

  save(_value: any, valid: boolean) {
    if (valid) {
      console.log('Everything is OK!');
    }
  }

}
